import { useI18n } from '../../i18n/I18nProvider';
import { DateField } from '../../ui/DatePicker';
import { SelectField } from '../../ui/Select';
import styles from './Receipt.module.css';

/**
 * The two mandatory return fields of a return without reference (RWR): `documentUseReason` and
 * `salesIssuedDateTime`. Shown together, both required; the editor refuses to save until they are
 * present (docs/council/reviews §9.3, return header).
 */
export function RwrFields({
  reason,
  saleDate,
  onReason,
  onSaleDate,
  reasonError,
  saleDateError,
}: {
  reason: 'I' | 'B' | null;
  /** 'YYYY-MM-DD' or null. */
  saleDate: string | null;
  onReason: (value: 'I' | 'B' | null) => void;
  onSaleDate: (value: string | null) => void;
  /** The server's refusal of either field, shown on the field itself (RB3R8-12). */
  reasonError?: string | undefined;
  saleDateError?: string | undefined;
}) {
  const { t } = useI18n();
  return (
    <section className={styles.card} data-testid="rwr-fields">
      <h2 className={styles.cardTitle}>{t.receipts.editor.returnTitleField}</h2>
      <p className={styles.subtle}>{t.receipts.editor.rwrMandatory}</p>
      <div className={styles.formGrid}>
        <SelectField
          label={t.receipts.editor.documentUseReason}
          fieldName="documentUseReason"
          isRequired
          placeholder={t.receipts.editor.choose}
          options={[
            { id: 'I', label: t.receipts.editor.useReasons.I },
            { id: 'B', label: t.receipts.editor.useReasons.B },
          ]}
          value={reason}
          errorMessage={reasonError}
          onChange={(value) => onReason((value as 'I' | 'B' | null) ?? null)}
        />
        <DateField
          label={t.receipts.editor.salesIssuedDateTime}
          fieldName="salesIssuedDateTime"
          isRequired
          description={t.receipts.editor.salesIssuedDateTimeHint}
          value={saleDate}
          errorMessage={saleDateError}
          onChange={onSaleDate}
        />
      </div>
    </section>
  );
}
